import { Box, Tab, Tabs, useThemeProps } from "@mui/material";
import { styled } from "@mui/styles";
import React from "react";
import { useThemeProvider } from "../../providers/ThemeProvider";

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: <span className="MuiTabs-indicatorSpan" />,
    }}
  />
))(({ theme }) => ({
  height: 30,
  minHeight: "30px !important",

  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 30,
    padding: 2,
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: theme.palette.theme.main,
    borderRadius: 7,
  },
}));

export const BoxedTabComponent = ({
  value,
  setValue,
  children,
  onItemChanged,
}) => {
  const theme = useThemeProvider();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onItemChanged(newValue);
  };

  return (
    <Box className={theme.styles.classes.componentsTabBoxedContainer}>
      <StyledTabs
        value={value.toString()}
        onChange={handleChange}
        variant="fullWidth"
      >
        {children}
      </StyledTabs>
    </Box>
  );
};

export const BoxedTabItemComponent = styled((props) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  zIndex: 1,
  fontSize: "13px !important",
  height: 30,
  minHeight: "30px !important",
  "&.Mui-selected": {
    color: `${theme.palette.text.primary} !important`,
  },
  "&.Mui-focusVisible": {
    backgroundColor: "rgba(100, 95, 228, 0.32)",
  },
}));
